@if (hasPermission()) {
	<a (click)="permittedClick.emit()">{{ linkText }}</a>
} @else {
	{{ disabledText }}
}
